<footer class="page-footer">
  <span>© {{date | date: 'yyyy'}} Habitat Nutrition. Todos los derechos reservados.</span>&nbsp;
  <a class="grey-text text-lighten-4 right" href="mailto:info@demo.mx">info@demo.mx</a>
  <a class="grey-text text-lighten-4 right" href="#">Política de Privacidad</a>
</footer>
